import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Only French is bundled inline (default / fallback language).
// All other locales are loaded on demand via dynamic import().
import translationFR from './locales/fr.json';

const localeLoaders = {
  am: () => import('./locales/am.json'),
  de: () => import('./locales/de.json'),
  en: () => import('./locales/en.json'),
  es: () => import('./locales/es.json'),
  it: () => import('./locales/it.json'),
  pt: () => import('./locales/pt.json'),
  ru: () => import('./locales/ru.json'),
  sq: () => import('./locales/sq.json'),
  tr: () => import('./locales/tr.json')
};

// Dynamically load a locale and register it with i18next
function loadLocale(lng) {
  const loader = localeLoaders[lng];
  if (!loader) return Promise.resolve(); // unknown or already-bundled (fr)
  return loader().then((mod) => {
    i18n.addResourceBundle(lng, 'translation', mod.default || mod, true, true);
  });
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: translationFR }
    },
    fallbackLng: 'fr',
    debug: false,

    interpolation: {
      escapeValue: false
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },

    // react-i18next will use Suspense / useSuspense by default;
    // keep it disabled so the app renders immediately with FR
    // and swaps once the real locale is ready.
    react: {
      useSuspense: false
    }
  });

// After init, if the detected language is not French, load it now.
const detected = i18n.language?.split('-')[0]; // handle "de-CH" → "de"
if (detected && detected !== 'fr' && localeLoaders[detected]) {
  loadLocale(detected).then(() => {
    i18n.changeLanguage(detected);
  });
}

// Hook into future language changes so switching via LanguageSwitcher
// automatically loads the locale on demand.
i18n.on('languageChanged', (lng) => {
  const base = lng?.split('-')[0];
  if (base && base !== 'fr' && localeLoaders[base] && !i18n.hasResourceBundle(base, 'translation')) {
    loadLocale(base);
  }
});

export default i18n;
